var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAminity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15v-60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V85h15a15 15 0 0115 15v60a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5v-60a5 5 0 00-5-5H55a5 5 0 00-5 5v60a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm0-80h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 60a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5zm-50 0a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAminity);
export default __webpack_public_path__ + "static/media/aminity.9e0dd74f13d77fa2414bec29c6983227.svg";
export { ForwardRef as ReactComponent };